import { render, staticRenderFns } from "./InputsVX.vue?vue&type=template&id=0c58c92e&"
import script from "./InputsVX.vue?vue&type=script&lang=js&"
export * from "./InputsVX.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports